import { z } from 'zod';

import { UuidSchema } from '@repo/validation';
export const ChannelSchema = z.enum(['SMS', 'PUSH', 'EMAIL']);
export type Channel = z.infer<typeof ChannelSchema>;

export const LocaleSchema = z.enum(['ta', 'en']);
export type Locale = z.infer<typeof LocaleSchema>;

export const DeliveryStatusSchema = z.enum(['QUEUED', 'SENT', 'DELIVERED', 'FAILED', 'UNDELIVERED']);
export type DeliveryStatus = z.infer<typeof DeliveryStatusSchema>;

export const RecipientTypeSchema = z.enum(['staff', 'agent', 'customer', 'surety', 'external']);
export type RecipientType = z.infer<typeof RecipientTypeSchema>;

export const TemplateListItemSchema = z.object({
  id: UuidSchema,
  templateKey: z.string(),
  channel: ChannelSchema,
  locale: LocaleSchema,
  isActive: z.boolean(),
  updatedAt: z.string(),
});
export type TemplateListItem = z.infer<typeof TemplateListItemSchema>;

export const TemplateDetailSchema = TemplateListItemSchema.extend({
  subject: z.string().nullable(),
  bodyTemplate: z.string(),
  dltTemplateId: z.string().nullable(),
});
export type TemplateDetail = z.infer<typeof TemplateDetailSchema>;

export const TemplateCreateSchema = z.object({
  templateKey: z.string().min(1, 'Template key is required'),
  channel: ChannelSchema,
  locale: LocaleSchema,
  subject: z.string(),
  bodyTemplate: z.string().min(1, 'Body template is required'),
  dltTemplateId: z.string(),
  isActive: z.boolean().default(true),
});
export type TemplateCreate = z.infer<typeof TemplateCreateSchema>;

export const TemplateUpdateSchema = TemplateCreateSchema.partial();
export type TemplateUpdate = z.infer<typeof TemplateUpdateSchema>;

export const LogListItemSchema = z.object({
  id: UuidSchema,
  templateKey: z.string(),
  channel: ChannelSchema,
  recipientType: RecipientTypeSchema,
  recipientMobile: z.string().nullable(),
  recipientEmail: z.string().nullable(),
  status: DeliveryStatusSchema,
  providerRef: z.string().nullable(),
  createdAt: z.string(),
});
export type LogListItem = z.infer<typeof LogListItemSchema>;

export const LogDetailSchema = LogListItemSchema.extend({
  renderedBody: z.string(),
  retryCount: z.number(),
  failureReason: z.string().nullable(),
  sentAt: z.string().nullable(),
  deliveredAt: z.string().nullable(),
  failedAt: z.string().nullable(),
});
export type LogDetail = z.infer<typeof LogDetailSchema>;
